import { DialogContentText } from "@material-ui/core";
import ActionDialog from "@saleor/components/ActionDialog";
import { WindowTitle } from "@saleor/components/WindowTitle";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import {
  useActiveBatchDetailsReportQuery as useBatchDetailsReportQuery,
  useBatchDetailsQuery
} from "@saleor/reports/batch/queries";
import { batchHistoryDetailsDownload } from "@saleor/reports/batchHistory/utils/handlers";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import _ from "lodash";
import * as React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { batchHistoryDetailsUrl, BatchHistoryUrlQueryParams } from "../../urls";
import BatchHistoryDetailsPage from "./../../components/BatchHistoryDetailsPage";
interface BatchHistoryDetailsProps {
  params: BatchHistoryUrlQueryParams;
  id: string;
}

const BatchHistoryDetails: React.FC<BatchHistoryDetailsProps> = props => {
  const { id, params } = props;
  const intl = useIntl();
  const notify = useNotifier();
  const navigate = useNavigator();

  const { data, loading } = useBatchDetailsQuery({
    displayLoader: true,
    skip: false,
    variables: {
      id
    }
  });

  const { data: BatchDetailsReport } = useBatchDetailsReportQuery({
    displayLoader: true,
    // skip: listElements.length === 0,
    variables: {
      ids: [id]
    }
  });

  const [openModal, closeModal] = createDialogActionHandlers(
    navigate,
    params => batchHistoryDetailsUrl(id, params),
    params
  );

  const arr = BatchDetailsReport?.activeBatchDetailsReport.edges.map(
    a => a.node
  );

  const handleDownload = async () => {
    await batchHistoryDetailsDownload(arr).finally(() => {
      notify({
        status: "success",
        text: "Successfully downloaded the report"
      });
      closeModal();
    });
  };

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Batch History",
          description: "window title"
        })}
      />
      <BatchHistoryDetailsPage
        batchDetails={data?.batchDetails?.data}
        loading={loading}
        onDownload={() => openModal("download")}
      />
      <ActionDialog
        open={params.action === "download"}
        onClose={closeModal}
        confirmButtonState="default"
        onConfirm={handleDownload}
        variant="default"
        title={intl.formatMessage({
          defaultMessage: "Download Batch",
          description: "dialog title"
        })}
      >
        <DialogContentText>
          <FormattedMessage
            defaultMessage="You are about to download batch with {total} row{s}. Do you want to continue?"
            values={{
              s: arr?.length > 1 ? "s" : "",
              total: arr?.length
            }}
          />
        </DialogContentText>
      </ActionDialog>
    </>
  );
};
export default BatchHistoryDetails;
